import { IconButton, Input, Option, Select, Sheet, Table, Textarea, Typography } from '@mui/joy';
import React, { useState } from 'react';
import { IOfferPosition } from '../interface/IOfferPosition';
import { deutschNumberFormatter } from '../helper/utils';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { OfferType } from '../interface/IOffer';
import { DeleteOutline } from '@mui/icons-material';

type Props = {
  offerPositions: Partial<IOfferPosition>[];
  onChange: (key: string, value: any, index: number) => void;
  onDelete: (index: number) => void;
  status: string;
};

function Row({
  row,
  onChange,
  onDelete,
  initialOpen,
  status,
}: {
  row: Partial<IOfferPosition>;
  onChange: (key: string, value: any) => void;
  onDelete: () => void;
  status: string;
  initialOpen: boolean;
}) {
  // const offerTotalTimeInvoiced = useCallback(() => {
  //   const totalTimeInvoiced = row.epics.reduce((total, epic) => {
  //     const epicTimeInvoiced = epic.logs.reduce((epicTotal, log) => {
  //       return epicTotal + log.timeInvoiced;
  //     }, 0);
  //     return total + epicTimeInvoiced;
  //   }, 0);
  //   return totalTimeInvoiced;
  // }, [row]);
  const [open, setOpen] = useState(initialOpen || false);

  return (
    <React.Fragment>
      <tr>
        <td>
          <IconButton aria-label='expand row' variant='plain' color='neutral' size='sm' onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </td>
        <td>{row?.position}</td>
        <td>
          <Select size='sm' value={row?.rate || null} onChange={(e, value) => onChange('rate', value)}>
            <Option value='DEV'>DEV</Option>
            <Option value='PM'>PM</Option>
          </Select>
        </td>
        <td>
          <Select size='sm' value={row?.contractType || null} onChange={(e, value) => onChange('contractType', value)}>
            <Option value=''>Select Type</Option>
            {Object.values(OfferType).map((type) => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </td>
        <td>
          <Textarea size='sm' value={row?.subject || ''} onChange={(e) => onChange('subject', e.target.value)} />
        </td>
        <td style={{ textAlign: 'right' }}>{deutschNumberFormatter(row?.listPrice)}</td>
        <td style={{ textAlign: 'right' }}>{deutschNumberFormatter(row?.projectPrice)}</td>
        <td>
          <Input
            size='sm'
            type='number'
            slotProps={{
              input: {
                className: 'num-input',
                min: 0,
                step: 'any',
              },
            }}
            value={row?.days || ''}
            onChange={(e) => {
              // const formattedValue = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
              onChange('days', e.target.value);
            }}
          />
        </td>
        <td>
          <Input
            size='sm'
            type='number'
            slotProps={{
              input: {
                className: 'num-input',
                min: 0,
                step: 'any',
              },
            }}
            value={row?.hours || ''}
            onChange={(e) => onChange('hours', e.target.value)}
          />
        </td>
        <td style={{ textAlign: 'right' }}>{status == 'accepted' ? deutschNumberFormatter(row?.openBudget) : deutschNumberFormatter(0)}</td>
        <td style={{ textAlign: 'right' }}>
          <IconButton color='danger' size='sm' onClick={onDelete} variant='plain'>
            <DeleteOutline />
          </IconButton>
        </td>
      </tr>
      <tr>
        <td style={{ height: 0, padding: 0 }} colSpan={11}>
          {open && (
            <Sheet variant='soft' sx={{ p: 2, px: 10 }}>
              <Typography level='body-lg' component='div'>
                Description
              </Typography>
              <Textarea
                name='Outlined'
                placeholder='Type in here…'
                variant='outlined'
                size='sm'
                value={row?.description || ''}
                onChange={(e) => onChange('description', e.target.value)}
              />
            </Sheet>
          )}
        </td>
      </tr>
    </React.Fragment>
  );
}

const OfferPositionTable = ({ offerPositions, onDelete, onChange, status }: Props) => {
  return (
    <Sheet
      sx={{
        display: { xs: 'none', sm: 'initial' },
        width: '100%',
        borderRadius: 'sm',
        flexShrink: 1,
        overflowY: 'auto',
        minHeight: 0,
        maxHeight: 200,
      }}
    >
      <Table
        borderAxis='both'
        size='sm'
        sx={{
          '--TableCell-headBackground': 'var(--joy-palette-background-level1)',
          '--Table-headerUnderlineThickness': '1px',
          '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
          '--TableCell-paddingY': '4px',
          '--TableCell-paddingX': '8px',
        }}
      >
        <thead>
          <tr>
            <th style={{ width: '2.5%' }} aria-label='empty' />
            <th style={{ width: '2.5%' }}>Pos.</th>
            <th style={{ width: '5%' }}>Rate Type</th>
            <th style={{ width: '10%' }}>Type</th>
            <th style={{ width: '30%' }}>Subject</th>
            <th style={{ width: '5%' }}>List Price</th>
            <th style={{ width: '5%' }}>Project Price</th>
            <th style={{ width: '5%' }}>Days</th>
            <th style={{ width: '5%' }}>Hours</th>
            <th style={{ width: '5%' }}>OpenBudget</th>
            <th style={{ width: '3%' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {offerPositions.length > 0 &&
            offerPositions.map((row, offerPositionIndex) => (
              <Row
                initialOpen={false}
                key={row.position || Math.floor(Math.random() * 100)}
                row={row}
                onChange={(key, value) => onChange(key, value, offerPositionIndex)}
                onDelete={() => onDelete(offerPositionIndex)}
                status={status}
              />
            ))}
        </tbody>
      </Table>
    </Sheet>
  );
};

export default OfferPositionTable;
